import Router from "@/router/clean";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { App } from "vue";

/**
 * @description Serviço para chamar mensagem
 */
class MensagemService {
  /**
   * @description Propriedade para compartilhar instância vue
   */
  public static vueInstance: App;

  /**
   * @description Inicializa vue router
   */
  public static init(app: App<Element>) {
    MensagemService.vueInstance = app;
  }

  /**
   * @description Exibe mensagem de sucesso
   * @param texto: string
   * @param rota?: string
   * @returns void
   */
  //  texto = "Cadastro efetuado com sucesso!" as string,
  //   rota?: string
  public static async sucesso({
    texto = "Cadastro efetuado com sucesso!" as string,
    rota = "" as string,
  }) {
    return Swal.fire({
      text: texto,
      icon: "success",
      buttonsStyling: false,
      allowOutsideClick: false,
      confirmButtonText: "Continuar!",
      customClass: {
        confirmButton: "btn fw-semibold btn-light-primary",
      },
    }).then(() => {
      if (`${rota}` != "") Router.push(`${rota}`);
    });
  }

  /**
   * @description Exibe mensagem de erro
   * @param texto: string
   * @param rota?: string
   * @returns void
   */
  public static async erro({
    titulo = "" as string,
    texto = "Falha ao atualizar!" as string,
    rota = "" as string,
    confirmButtonText = "Tente Novamente" as string,
  }) {
    return Swal.fire({
      title: titulo,
      text: texto || "Ocorreu um erro",
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: confirmButtonText,
      customClass: {
        confirmButton: "btn fw-semibold btn-danger",
      },
    }).then(() => {
      if (`${rota}` != "") Router.push(`${rota}`);
    });
  }

  /**
   * @description Exibe mensagem de alerta para retorno de página
   * @param texto: string
   * @param rota?: string
   * @returns void
   */
  public static async retorno({
    texto = "Tem certeza que deseja voltar? Ao sair, você perderá todos os dados" as string,
    rota = "/" as string,
  }) {
    return Swal.fire({
      text: texto,
      icon: "warning",
      buttonsStyling: false,
      showCancelButton: true,
      isDismissed: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Confirmar",
      customClass: {
        confirmButton: "btn fw-semibold btn-primary",
        cancelButton: "btn fw-semibold btn-danger",
      },
    }).then((result) => {
      if (result.value) {
        Router.push(`${rota}`);
      }
    });
  }

  public static async acao({
    texto = "Tem certeza que deseja voltar? Ao sair, você perderá todos os dados" as string,
    callbackAction = (confirmed) => {
      console.log("callbackAction", confirmed);
    },
  }) {
    return Swal.fire({
      text: texto,
      icon: "warning",
      buttonsStyling: false,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Confirmar",
      customClass: {
        confirmButton: "btn fw-semibold btn-primary",
        cancelButton: "btn fw-semibold btn-danger",
      },
    }).then((result) => {
      if (result.value) {
        callbackAction(result.value);
      }
    });
  }

  public static async gotoHome({
    texto = "Deseja sair desse módulo?" as string,
    rota = "/" as string,
  }) {
    return Swal.fire({
      text: texto,
      icon: "warning",
      buttonsStyling: false,
      showCancelButton: true,
      isDismissed: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
      customClass: {
        confirmButton: "btn fw-semibold btn-primary",
        cancelButton: "btn fw-semibold btn-danger",
      },
    }).then((result) => {
      if (result.value) {
        if (`${rota}` != "") {
          window.location.href = `${rota}`;
        }
      }
    });
  }
}

export default MensagemService;
